import { useAppSelector } from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';
import { ViewResolver } from '@Components/ViewResolver';
import { useNavigate } from 'react-router-dom';
import LeaveBalanceDesktop from './desktop';
import LeaveBalanceMobile from './mobile';

const LeaveBalance: React.FC = () => {
  const navigate = useNavigate();
  const currentUser = useAppSelector(currentUserSelector);
  const handleGoToProfilePage = (): void =>
    navigate('ess/profile/details', { state: { activeTab: 'LeaveBalance' } });

  return (
    <ViewResolver
      desktop={
        <LeaveBalanceDesktop
          user={currentUser}
          handleGoToProfilePage={handleGoToProfilePage}
        />
      }
      mobile={
        <LeaveBalanceMobile
          user={currentUser}
          handleGoToProfilePage={handleGoToProfilePage}
        />
      }
    />
  );
};

export default LeaveBalance;
